import { RequestStatus } from 'typed/api';
import { NetworkObject } from 'typed/api/entities';
import { ActionType, Action } from 'typed/actions';
import { IReducer, networkActionReducer } from './';
import { deepAssign, deepClone } from 'typed/utils';

export default function networkObjectLoadReducer<T extends ActionType, O>(type: T, def: NetworkObject<O>): IReducer<NetworkObject<O>, Action<T>>;
export default function networkObjectLoadReducer(type: any, def?: any): IReducer<any, any> {
    const nr = networkActionReducer<any, any>(type);
    return function networkObjectLoadReducer(state = deepClone(def), action) {
        state = nr(state, action);

        if (action.type === type && action.payload.status === RequestStatus.SUCCEEDED) {
            return deepAssign(state, { Data: action.payload.response });
        }

        return state;
    }
}
